import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { RearrangeStatusesDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  data: RearrangeStatusesDTO;
  stageUid: string;
}

export const useStageStatusReorderQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ data, stageUid }: IParams) => {
      return await Api.orders.postStageRearrangeStatus(stageUid, data);
    },
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: async (data) => {
      await client.invalidateQueries(['getProcess']);
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
      return data;
    },
  });
};
